var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isAuthtorized() && _vm.$route.fullPath !== "/login"
        ? _c(
            "el-container",
            { staticStyle: { height: "100vh" } },
            [
              _vm.isMobile
                ? _c(
                    "el-header",
                    {
                      staticClass: "main-header",
                      staticStyle: { flex: "0 0 55px" },
                    },
                    [
                      _c("div", { staticClass: "navbar-toggler" }, [
                        _vm.isOpen
                          ? _c("i", {
                              staticClass: "header-icon el-icon-s-fold",
                              on: {
                                click: function ($event) {
                                  return _vm.isOpenMenu("2")
                                },
                              },
                            })
                          : _c("i", {
                              staticClass: "header-icon el-icon-s-unfold",
                              on: {
                                click: function ($event) {
                                  return _vm.isOpenMenu("4")
                                },
                              },
                            }),
                      ]),
                      _c("div", { staticClass: "logo" }, [
                        _c("a", { attrs: { href: "/" } }, [
                          _c("img", {
                            staticStyle: { width: "100px" },
                            attrs: {
                              alt: "",
                              src: require("@/assets/logo.png"),
                            },
                          }),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm.isOpen ? _c("MenuTop") : _vm._e(),
              _c(
                "el-container",
                [
                  _c(
                    "el-main",
                    { staticClass: "container-fluid" },
                    [_c("router-view")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }